import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/redux/app.state';
import { NotificationService } from 'src/app/services/notification.service';
import { Warehouse, WarehouseCell } from 'src/typings';
import { WarehouseService } from '../warehouse.service';

@Component({
  selector: 'app-warehouse-cell-manager',
  templateUrl: './cell-manager.component.html',
  styleUrls: ['./cell-manager.component.scss']
})
export class CellManagerComponent implements OnInit {
  constructor(
    private readonly warehouseService: WarehouseService,
    private readonly notificationService: NotificationService,
    private readonly store: Store<AppState>
  ) {
    this.store.subscribe((state) => {
      const defaultWarehouse = state.user.info?.defaultWarehouse;
      if (!this.warehouseControl.value && defaultWarehouse) {
        this.warehouseControl.setValue(defaultWarehouse);
      }
    });
  }

  warehouseControl = new UntypedFormControl();
  codeControl = new UntypedFormControl('');
  searchControl = new UntypedFormControl('');

  cells: WarehouseCell[] = [];
  loading = false;
  displayedColumns = ['code', 'type', 'active', 'action'];

  ngOnInit(): void {
    this.warehouseControl.valueChanges.subscribe(() => {
      this.loadCells();
    });
  }

  get warehouse(): Warehouse | undefined {
    return this.warehouseControl.value as Warehouse;
  }

  loadCells() {
    if (!this.warehouse?.id) {
      this.cells = [];
      return;
    }
    this.loading = true;
    this.warehouseService
      .searchCells({
        warehouseId: this.warehouse.id,
        code: this.searchControl.value,
        includeInactive: true
      })
      .subscribe({
        next: (cells) => {
          this.cells = cells;
          this.loading = false;
        },
        error: () => {
          this.loading = false;
          this.notificationService.warning('Не удалось загрузить список ячеек');
        }
      });
  }

  createCell() {
    if (!this.warehouse?.id || !String(this.codeControl.value || '').trim()) {
      return this.notificationService.warning('Выбери склад и введи код ячейки');
    }

    this.warehouseService
      .createCell({
        warehouseId: this.warehouse.id,
        code: String(this.codeControl.value)
      })
      .subscribe({
        next: () => {
          this.codeControl.setValue('');
          this.notificationService.notice('Ячейка сохранена');
          this.loadCells();
        },
        error: () => this.notificationService.warning('Не удалось сохранить ячейку')
      });
  }

  toggleActive(cell: WarehouseCell) {
    this.warehouseService
      .updateWarehouseCell({
        id: cell.id,
        isActive: !cell.isActive
      })
      .subscribe({
        next: () => this.loadCells(),
        error: () => this.notificationService.warning('Не удалось обновить ячейку')
      });
  }
}
